import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { getCategoryList } from 'app/api/category';
import { getMallList } from 'app/api/mall';
import {
  addStore,
  getStoreById,
  updateStore,
  uplaodMedia,
} from 'app/api/store';
import {
  storeValidationRules,
  validate,
} from 'app/constants/validation-constants';
import Message from 'app/utils/Message';
import {
  convertTo12HourFormat,
  convertTo24HourFormat,
} from 'app/utils/Parsers';
import Toast from 'app/utils/Toast';
import { APP_CONSTANTS } from 'app/constants/app-constants';

const useCreateStore = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [mallList, setMallList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [pageLoading, setPageLoading] = useState(false);
  const [error, setErrors] = useState({});
  const [values, setValues] = useState({
    storeName: '',
    description: '',
    location: '',
    contactNumber: '',
    mallId: null,
    categoryId: null,
    subCategoryId: null,
    partOfReward: '',
    managerDetailsName: '',
    managerPhoneNumber: '',
    managerEmail: '',
    coverImage: null,
    additionalImage: null,
    logo: null,
    status: true,
    storeOpeningTime: '10:00',
    storeClosingTime: '17:00',
    type: '',
    isCdit: '',
  });

  const storeId = location?.state?.id ? location?.state?.id : '';

  useEffect(() => {
    getMallListforDropdown();
    getCategoryListforDropdown();
  }, []);

  useEffect(() => {
    if (categoryList.length > 0 && storeId) {
      loadStoreData(storeId);
    }
  }, [categoryList]);

  async function getMallListforDropdown() {
    setPageLoading(true);
    let response = await getMallList(1);
    setPageLoading(false);
    if (response && response?.responseCode === 200) {
      let temp = await response?.data?.malls?.map((item, index) => {
        return {
          ...item,
          value: item.id,
          label: item.name,
        };
      });
      setMallList(temp);
    } else {
      Toast.error(
        response?.data ? response?.data : Message?.Error?.COMMON_MESSAGE
      );
    }
  }
  async function getCategoryListforDropdown() {
    setPageLoading(true);
    let response = await getCategoryList();
    setPageLoading(false);
    if (response && response?.responseCode === 200) {
      let temp = await response?.data?.map((item, index) => {
        return {
          ...item,
          value: item.id,
          label: item.name,
        };
      });
      setCategoryList(temp);
    } else {
      Toast.error(
        response?.data ? response?.data : Message?.Error?.COMMON_MESSAGE
      );
    }
  }
  const loadStoreData = async (id) => {
    if (!id) {
      return;
    }
    setPageLoading(true);
    let response = await getStoreById(id);
    setPageLoading(false);
    if (response?.responseCode === 200) {
      let responsedata = response?.data;
      setValues((prevState) => ({
        ...prevState,
        ...responsedata,
        type: responsedata?.type,
        isCdit: responsedata?.isCdit ? 'yes' : 'no',
        partOfReward: responsedata?.partOfReward ? 'yes' : 'no',
        managerDetailsName: responsedata?.managerDetails?.name,
        managerPhoneNumber: responsedata?.managerDetails?.phoneNumber,
        managerEmail: responsedata?.managerDetails?.email,
        categoryId: responsedata?.parentId,
        subCategoryId: parseInt(responsedata?.categoryId),
        storeOpeningTime:
          responsedata?.storeOpeningTime &&
          convertTo24HourFormat(responsedata?.storeOpeningTime),
        storeClosingTime:
          responsedata?.storeClosingTime &&
          convertTo24HourFormat(responsedata?.storeClosingTime),
      }));

      const selectedCategory = categoryList?.find(
        (item) => item?.id === responsedata?.parentId
      );
      if (selectedCategory) {
        const formattedSubCategories = selectedCategory?.subCategories?.map(
          (subCategory) => ({
            label: subCategory.name,
            value: subCategory.id,
            ...subCategory,
          })
        );

        setSubCategoryList([...formattedSubCategories]);
      } else {
        setSubCategoryList([]);
      }
    } else {
      Toast.error(
        response?.response?.message
          ? response?.response?.message
          : Message.Error.COMMON_MESSAGE
      );
    }
  };

  async function callAddOrUpdateAPI() {
    setPageLoading(true);
    let response = {};
    let senddata = {
      ...values,
      parentId: values.categoryId,
      categoryId: values?.subCategoryId,
      storeOpeningTime: convertTo12HourFormat(values.storeOpeningTime),
      storeClosingTime: convertTo12HourFormat(values.storeClosingTime),
      isCdit: values.isCdit === 'yes' ? true : false,
      partOfReward: values.partOfReward === 'yes' ? true : false,
      managerDetails: {
        name: values.managerDetailsName,
        email: values.managerEmail,
        phoneNumber: values.managerPhoneNumber,
      },
    };
    delete senddata?.subCategoryId;
    delete senddata?.managerDetailsName;
    delete senddata?.managerEmail;
    delete senddata?.managerPhoneNumber;
    delete senddata?.parentId;
    if (storeId) {
      response = await updateStore(storeId, { ...senddata });
    } else {
      response = await addStore({ ...senddata });
    }
    setPageLoading(false);
    if (response?.responseCode === 200) {
      Toast.success(
        storeId
          ? Message.Stores.UPDATED_SUCCESS
          : Message.Stores.CREATED_SUCCESS
      );
      if (values?.type === 'store') {
        navigate(-1);
      } else {
        if (storeId) {
          navigate(-1);
        } else {
          handleNew(response?.data?.createdStore?.id);
        }
      }
    } else {
      Toast.error(
        response?.response?.message
          ? response?.response?.message
          : Message.Error.COMMON_MESSAGE
      );
    }
  }
  function handleCreateStore(e) {
    e.preventDefault();
    const validationErrors = validate(values, storeValidationRules);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      callAddOrUpdateAPI();
    }
  }
  function resetValues() {
    setValues({
      id: '',
      code: '',
      storeName: '',
      description: '',
      product_type: '',
      max_usage_per_user: 1,
      discount: null,
      min_value_required: null,
      max_discount_amount: null,
      status: false,
      product_family: '',
    });
  }
  function handleChange(e) {
    if (e && e.target) {
      const { name, value } = e.target;
      setValues({
        ...values,
        [name]:value
      });

      if (error[name]) {
        setErrors({
          ...error,
          [name]: '',
        });
      }
    }
  }
  function handleSelectSubCategory(e) {
    if (e && e.target) {
      setSubCategoryList([]);
      const { name, value } = e.target;
      setValues({
        ...values,
        [name]: value,
        subCategoryId: null,
      });
      if (error[name]) {
        setErrors({
          ...error,
          [name]: '',
          subCategoryId: '',
        });
      }
      const selectedSubCategory = categoryList.find(
        (item) => item.id === value
      );
      if (selectedSubCategory) {
        const formattedSubCategories = selectedSubCategory.subCategories.map(
          (subCategory) => ({
            label: subCategory.name,
            value: subCategory.id,
            ...subCategory,
          })
        );
        setSubCategoryList(formattedSubCategories);
      } else {
        setSubCategoryList([]);
      }
    }
  }
  function setChange(name, val) {
    setValues((prevState) => ({
      ...prevState,
      [name]: val,
    }));
    setErrors({
      ...error,
      [name]: '',
    });
  }
  async function uploadMediaHandler(file, name) {
    if (!file) {
      setChange(name, null);
      return;
    }
    const response = await uplaodMedia(file);
    if (response.responseCode === 200) {
      Toast.success('Image upload Successfull');
      const data = await response.data;
      setChange(name, data?.url);
    } else {
      Toast.error(
        response?.response?.message
          ? response?.response?.message
          : Message.Error.COMMON_MESSAGE
      );
    }
  }
  function handleTime(value, name) {
    setValues((prevValues) => {
      const newValues = { ...prevValues, [name]: value };
      if (
        name === 'storeOpeningTime' &&
        newValues.storeClosingTime &&
        new Date(`1970-01-01T${newValues.storeClosingTime}`) <=
          new Date(`1970-01-01T${value}`)
      ) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          storeClosingTime: 'Closing time must be after opening time.',
        }));
      } else if (
        name === 'storeClosingTime' &&
        newValues.storeOpeningTime &&
        new Date(`1970-01-01T${value}`) <=
          new Date(`1970-01-01T${newValues.storeOpeningTime}`)
      ) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          storeClosingTime: 'Closing time must be after opening time.',
        }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          storeClosingTime: '',
        }));
      }
      return newValues;
    });
    if (error[name]) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: '',
      }));
    }
  }
  function handleNew(id) {
    navigate(`/menu/store/:${id}`, {
      state: {
        id,
      },
    });
  }
  return {
    mallList,
    categoryList,
    subCategoryList,
    resetValues,
    handleChange,
    values,
    error,
    setValues,
    handleCreateStore,
    pageLoading,
    handleSelectSubCategory,
    storeId,
    uploadMediaHandler,
    navigate,
    setChange,
    handleTime,
  };
};

export default useCreateStore;
